import { usePermissions } from '@ltvco/refresh-lib/ctx';
import { PerksPage, useSession } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';

import { FreeUserRewardContainer } from 'components/Rewards/FreeUserRewardContainer';

export function RewardsPage() {
  const { isPremiumFeatureAllowedForFreePlanUsers } = usePermissions();
  const {
    session: { account },
  } = useSession();
  const cannotAccessRewards =
    !isPremiumFeatureAllowedForFreePlanUsers('rewards_access') &&
    account?.account?.subscription_info?.free_user;

  useEffect(() => {
    document.title = 'Rewards - Bumper';
  }, []);

  return cannotAccessRewards ? (
    <FreeUserRewardContainer displayCTABanner={true} displayBenefits={true} />
  ) : (
    <PerksPage title="Rewards" filterByCategories={true} />
  );
}
